// EOWorld staff graphics corresponding to server item IDs:
// 23, 29, 205, 206, 224, 290, 329, 362, 389, 390, 421, 455, 497, 599.
//
// Graphic 46 is shared by Staff and Staff Staff.
const AOE_STAFF_GRAPHICS = new Set<number>([
  40,
  46,
  213,
  214,
  220,
  295,
  328,
  360,
  383,
  384,
  412,
  446,
  // Staff Of Dekio (item 599): basic two-tile line AoE.
  677,
  // Bazar Axe (item 598): centered 3x3 melee sweep; not a staff animation.
  635,
]);

export function isAoeStaffGraphic(graphicId: number): boolean {
  return AOE_STAFF_GRAPHICS.has(graphicId);
}
